import { useContext } from 'react';
import { FeatureFlagContext } from '../BaseSendEditor.context';

export default () => useContext(FeatureFlagContext);
